<template>
  <div class="user-rank" :class="{ 'user-rank-small': compact }">
    <UiGameAvatar
      :rank="rank"
      :img="img"
      :compact="compact"
      :alt="name"
    />
    <div class="border-2 border-solid w-full rounded-2xl bg-gradient-to-br from-50% to-[52%]" :class="[!compact ? 'p-4' : 'p-2', rankClass]">
      <div class="grow flex flex-col md:flex-row w-full">
        <div class="grow flex flex-col justify-center" :class="!compact ? 'gap-1' : ''">
          <div :class="!compact ? 'text-lg leading-4 font-semibold' : 'text-sm'">{{ name }}</div>
          <div :class="!compact ? 'text-sm' : 'text-xs'">{{ role }}</div>
        </div>
        <div class="flex items-center gap-3 text-base font-semibold text-black">
          <span>
            <CountTo :value="score || 0" /> <span class="text-sm font-normal">pts</span>
          </span>
          <img :src="ImgGamePoints" width="24" height="24" alt="points" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CountTo from '@/views/gestao/dashboard/components/counter.vue'

import UiGameAvatar from '@/components/ui/gamification/avatar.vue'
import ImgGamePoints from '@/assets/game/icon-points.svg'

const props = defineProps<{
  rank?: number
  name: string
  role: string
  img?: string
  score?: number
  compact?: boolean
}>()

const rankClass = computed(() => {
  if (props.rank === 1) return 'text-yellow-700 from-yellow-200 via-yellow-50 to-yellow-300 border-yellow-600'
  if (props.rank === 2) return 'text-gray-700 from-gray-300 via-gray-100 to-gray-400 border-gray-600'
  if (props.rank === 3) return 'text-[#9f5c21] from-[#fdc980] via-[#fff0dc] to-[#e49862] border-[#c16d41]'
  return 'text-gray-700 from-neutral-50 via-white to-neutral-200 border-neutral-400'
})
</script>

<style scoped lang="scss">
.user-rank {
  @apply flex items-center gap-4;

  &-small {
    .frame-content {
      @apply py-2 px-4;
    }
  }
}
</style>
